import { motion } from "framer-motion";

const MOUNTAIN_MARK = "/mountain-mark.png";

const mountainHero =
  "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?auto=format&fit=crop&w=1600&q=80";

const About = () => {
  return (
    <div data-testid="about-page" className="pt-32 pb-24">
      <section className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-[10px] uppercase tracking-label gold-text">
            About — Summit Scents
          </span>
          <h1 className="mt-6 font-serif text-5xl md:text-7xl leading-[1.0] tracking-tight">
            Only satisfied with<span className="italic gold-shimmer"> perfection.</span>
          </h1>
          <div className="divider-gold mx-auto mt-10" />
        </motion.div>
      </section>

      <section className="relative mt-24">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4 }}
          className="relative h-[60vh] max-w-[1400px] mx-auto px-6 md:px-12"
        >
          <div className="relative h-full w-full overflow-hidden border hairline">
            <img
              src={mountainHero}
              alt="Mountain summit"
              className="w-full h-full object-cover opacity-60"
              style={{ filter: "brightness(0.75) contrast(1.05)", objectPosition: "center 75%" }}
              data-testid="about-hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg)] via-[var(--bg)]/70 to-[var(--bg)]/40" />
          </div>
        </motion.div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-24 space-y-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.0 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10"
        >
          <div className="md:col-span-1">
            <p className="font-serif text-3xl md:text-4xl gold-text leading-tight">
              The Origin
            </p>
          </div>
          <div className="md:col-span-2 space-y-6 text-[var(--secondary-text)] leading-loose">
            <p className="font-serif text-2xl text-[var(--primary-text)]">
              Summit Scents was developed for those who aspire to be greater, for those who want more and are never satisfied.
            </p>
            <p>
              At Summit Scents, we value authenticity and dependability, making sure that all of our customers are satisfied with the product that they receive. At the forefront of our company lies a spirit of confidence and ambition, crafting fragrances for those who want the same.
            </p>

            <p>
              
            </p>
            <p>
              Founded in 2026, Summit Scents exists for those who look for both beauty and luxury within their fragrance. Creating a scent that fits all men has never been done...until now. We made it our mission to achieve this feat and meet the needs of every fragrance buyer.
              In a world where fragrances rarely meet the needs of individuals, fragrance users are quickly turning to Summit Scents because our ingredients, price, authenticity, and customer satisfaction are unmatched. Explore our Summit lineup and discover why we stand alone at the top of our class.
          
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.0 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t hairline pt-20"
        >
          <div className="md:col-span-1">
            <p className="font-serif text-3xl md:text-4xl gold-text leading-tight">
              Our Materials
            </p>
          </div>
          <div className="md:col-span-2 space-y-6 text-[var(--secondary-text)] leading-loose">
            <p className="font-serif text-2xl text-[var(--primary-text)]">
              We work exclusively with materials that deserve attention.
            </p>
            <p>
              Cedarwood, Mysore-grown sandalwood, Fresh vanilla, Amber, Calabrian bergamot - just to name a few.
              Each ingredient is selected for its richness, delicacy, and smooth aroma.
            </p>
            <p>
              
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.0 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t hairline pt-20"
        >
          <div className="md:col-span-1">
            <p className="font-serif text-3xl md:text-4xl gold-text leading-tight">
              The Promise
            </p>
          </div>
          <div className="md:col-span-2 space-y-6 text-[var(--secondary-text)] leading-loose">
            <p className="font-serif text-2xl text-[var(--primary-text)]">
              Everyone receives what they deserve.
            </p>
            <p>
             We do not cut corners, take shortcuts, or look ahead. We focus on the present moment, and how we can influence the modern day fragrance buyer. Not only do we use premium ingredients, we hand-bottle each product, making the Summit experience that much more unique. 
            </p>
            <div className="pt-6 flex items-center gap-4">
              <img src={MOUNTAIN_MARK} alt="" aria-hidden className="h-4 w-auto select-none" draggable={false} />
              <span className="text-[10px] uppercase tracking-label gold-text">
                Summit · Est. 2026
              </span>
            </div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default About;
